export default __webpack_public_path__ + "static/media/colorGuess.ee80dd40.png";